import { WFH } from '../actionTypes';

const initialState = {
    objTouchlineLastTick: {},
    objBestFiveLastTick: {},
     // Shuaib : 21/02/2024: Reconnection attempts - Start
    objTouchline:{},
    objBestFive:{},
    reconnectionCount: null
     // Shuaib : 21/02/2024: Reconnection attempts - End
};

const wfhReducer = (state = initialState, actions) => {
    switch (actions.type) {
        case WFH.UPDATE_TOUCHLINE_LAST_TICK: {
            return {
                ...state,
                objTouchlineLastTick: actions.payload
            };
        }
        case WFH.UPDATE_BESTFIVE_LAST_TICK: {
            return {
                ...state,
                objBestFiveLastTick: actions.payload
            };
        }
         // Shuaib : 21/02/2024: Reconnection attempts - Start
        case WFH.UPDATE_TOUCHLINE_OBJ : {
            return {
                ...state,
                objTouchline: actions.payload
            }
        }
        case WFH.UPDATE_BEST_FIVE_OBJ : {
            return {
                ...state,
                objBestFive: actions.payload
            }
        }
        case WFH.UPDATE_RECONNECTION_COUNT : {
            return {
                ...state,
                reconnectionCount: actions.payload
            }
        }
         // Shuaib : 21/02/2024: Reconnection attempts - End
        default:
            return state;
    }

};

export default wfhReducer;